export function mapBlock() {
    const mapButton = document.querySelector('#map-button');

    const interactiveMap = document.querySelector('.map-block__interactive');

    mapButton.addEventListener('click', () => {
        if (interactiveMap.classList.contains('map-block__interactive--active')) {
            interactiveMap.classList.remove('map-block__interactive--active');
            document.body.classList.remove('lightbox');
        } else {
            interactiveMap.classList.add('map-block__interactive--active');
            document.body.classList.add('lightbox');
        }
    });


}